window.vainillaGallery = require('./gallery');
